import Vue from "vue"
import DetailDescriptionComponent from "@/components/detail-description/detail-description.component.vue"
import TrainingPreviewComponent from "@/components/training-preview/training-preview.component.vue"
import EgymRoundPreviewComponent from "@/components/egym-round-preview/egym-round-preview.component.vue"
import workoutPreviewManager from "@/store/managers/workout-preview.manager"
import router from "@/router"
import { PAGES } from "@/types/router"
import { Component } from 'vue-property-decorator'
import { Location, NavigationGuardNext, Route } from 'vue-router'
import { CircuitWorkout, MssWorkout, WorkoutTypes } from '@/types/workouts'
import {eGymTrainingsModule} from "@/store/modules/egym-trainings.module";
import {egymWorkoutDescriptionModule} from "@/store/modules/egym-workout-descrtiption.module";

@Component({
  components: {
    'workout-details-component': DetailDescriptionComponent,
    'training-preview-component': TrainingPreviewComponent,
    'egym-round-preview': EgymRoundPreviewComponent
  },
  beforeRouteEnter: (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {

    const id = to.params.id;
    const activeWorkout = eGymTrainingsModule.workouts.find(activity => activity.id === id) as CircuitWorkout
    
    if (activeWorkout != undefined) {
      egymWorkoutDescriptionModule.init(activeWorkout)
      next()
    } else {
      router.back()
    }
  },
  beforeRouteLeave: (to: Route, from: Route, next: NavigationGuardNext<Vue>)  => {

    if (egymWorkoutDescriptionModule.previewMode) {
      egymWorkoutDescriptionModule.togglePreviewMode()

      // the workout start takes over the screens, so only stop the preview when leaving elsewhere
      if (to.name != PAGES.EGYM_TRAINING_ACTIVE) {
        workoutPreviewManager.stop(from.params.id, 'mss', 0)
      }
    }
    
    next()
  }
})
export default class EgymTrainingDescriptionPageComponent extends Vue {

  public activeWorkoutLocation = { name: PAGES.EGYM_TRAINING_ACTIVE } as Location

  public workoutPreviewRoundIdx?: number

  public workoutPreviewPartIdx = 0

  public isPreviewActive = false

  get id() {
    return this.$route.params.id
  }

  get workoutName() {
    return egymWorkoutDescriptionModule.workout?.name
  }

  get tags() {
    return egymWorkoutDescriptionModule.tags.slice(0,8)
  }

  get workoutDescription() {
    return egymWorkoutDescriptionModule.workoutDescription
  }

  get workoutPreviewSlidesData() {
    return egymWorkoutDescriptionModule.workoutPreviewSlidesData[0]
  }

  get coverImageUrl() {
    return egymWorkoutDescriptionModule.coverImageUrl
  }

  get equipmentTags() {
    return egymWorkoutDescriptionModule.equipmentTags
  }

  get fitnessTypeTag() {
    return ""
  }

  get previewIcon() {
    return this.isPreviewActive ? "theme-style timer-btn stop-icon icon-stop" : "theme-style timer-btn triangle-icon icon-tirangle-arrow-right"
  }

  created() {
    if (egymWorkoutDescriptionModule.workout != null) {
      this.workoutPreviewPartIdx = egymWorkoutDescriptionModule.workout?.warming_ups.length
      this.workoutPreviewRoundIdx = egymWorkoutDescriptionModule.workout?.type === WorkoutTypes.CIRCUIT ? 0 : -1
    }
  }

  togglePreviewMode() {

    egymWorkoutDescriptionModule.togglePreviewMode()

    if (this.id != undefined) {

      if (egymWorkoutDescriptionModule.previewMode) {
        workoutPreviewManager.start(this.id, 'mss',
          this.workoutPreviewPartIdx, this.workoutPreviewRoundIdx)
          this.isPreviewActive = true
      } else {
        workoutPreviewManager.stop(this.id, 'mss',
          this.workoutPreviewPartIdx, this.workoutPreviewRoundIdx)
          this.isPreviewActive = false
      } 
    }
  }

  onPreviewUpdate(d: { workoutPartIdx: number; roundIdx?: number }) {

    const { workoutPartIdx, roundIdx } = d

    if (egymWorkoutDescriptionModule.workout?.id && egymWorkoutDescriptionModule.previewMode) {
      if (workoutPartIdx != this.workoutPreviewPartIdx) {
        workoutPreviewManager.changeWorkoutPart(egymWorkoutDescriptionModule.workout.id, 'mss',
          workoutPartIdx, roundIdx)
      } else if (roundIdx != undefined && roundIdx != this.workoutPreviewRoundIdx) {
        workoutPreviewManager.changeRound(egymWorkoutDescriptionModule.workout.id, 'mss',
          workoutPartIdx, roundIdx)
      }
    }

    this.workoutPreviewPartIdx = workoutPartIdx
    this.workoutPreviewRoundIdx = roundIdx
  }

  returnBack() {
    return this.$router.back()
  }
}